(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vspots-product-content"] && !Shopify.designMode) return;
  try {
    
  class VspotsProductTabs extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;

      this.dataset.initialized = 'true';
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.panels = [...this.querySelectorAll('[role="tabpanel"]')];

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activateTab(tab));
        tab.addEventListener('keydown', (event) => this.handleKeydown(event));
      });
    }

    activateTab(activeTab, moveFocus = false) {
      const panelId = activeTab.getAttribute('aria-controls');

      this.tabs.forEach((tab) => {
        const isActive = tab === activeTab;
        tab.setAttribute('aria-selected', String(isActive));
        tab.tabIndex = isActive ? 0 : -1;
      });

      this.panels.forEach((panel) => {
        panel.hidden = panel.id !== panelId;
      });

      if (moveFocus) activeTab.focus();
    }

    handleKeydown(event) {
      const currentIndex = this.tabs.indexOf(event.currentTarget);
      let nextIndex = currentIndex;

      if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
      if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.tabs.length - 1;
      if (nextIndex === currentIndex) return;

      event.preventDefault();
      this.activateTab(this.tabs[nextIndex], true);
    }
  }

  if (!customElements.get('vspots-product-tabs')) {
    customElements.define('vspots-product-tabs', VspotsProductTabs);
  }

  } catch(e) { console.error(e); }
})();
})();
